const initialState = {
  pages: [],
  requestPending: null,
  pageStatusDropdown: false,
  pageModal: false
};

const header = (state = initialState, action) => {
  switch (action.type) {
    case "SET_PAGES":
      return {
        ...state,
        pages: action.payload
      };
    case "HEADER_SET_REQUEST_PENDING":
      return {
        ...state,
        requestPending: action.payload
      };
    case "HEADER_STATUS_DROPDOWN":
      return {
        ...state,
        pageStatusDropdown: action.payload
      };
    case "HEADER_MODAL":
      return {
        ...state,
        pageModal: action.payload
      };
    default:
      return state;
  }
};

export default header;
